import { render, staticRenderFns } from "./import-button.vue?vue&type=template&id=1083c883&scoped=true"
import script from "./import-button.vue?vue&type=script&lang=js"
export * from "./import-button.vue?vue&type=script&lang=js"
import style0 from "./import-button.vue?vue&type=style&index=0&id=1083c883&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083c883",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1083c883')) {
      api.createRecord('1083c883', component.options)
    } else {
      api.reload('1083c883', component.options)
    }
    module.hot.accept("./import-button.vue?vue&type=template&id=1083c883&scoped=true", function () {
      api.rerender('1083c883', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/admin/import-button.vue"
export default component.exports